import Line from './Line';

export default Line;
